import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { isForbiddenApiError } from '@omnea-app/packages/universal/error-handling/isApiErrorOfType'
import { invalidateRecordAccess, isRecordAccessQueryKey } from './recordAccessQuery'

/** A 403 from any request means a cached access answer is wrong, so every record answer is refetched. */
export const useInvalidateRecordAccessOnForbidden = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    const onError = (error: unknown) => {
      if (isForbiddenApiError(error)) void invalidateRecordAccess(queryClient)
    }
    const unsubscribeQueries = queryClient.getQueryCache().subscribe((event) => {
      // The record queries themselves are excluded, or a forbidden answer would refetch itself forever.
      if (event.type !== 'updated' || event.action.type !== 'error' || isRecordAccessQueryKey(event.query.queryKey)) return
      onError(event.action.error)
    })
    const unsubscribeMutations = queryClient.getMutationCache().subscribe((event) => {
      if (event.type === 'updated' && event.action.type === 'error') onError(event.action.error)
    })
    return () => {
      unsubscribeQueries()
      unsubscribeMutations()
    }
  }, [queryClient])
}
